import type { State } from '../shared/types';

export const TOKEN_KEY = 'inbar-token';
export const CACHE_KEY = 'inbar-cache';

export type PutResult =
  | { ok: true; state: State }
  | { ok: false; kind: 'conflict'; state: State }
  | { ok: false; kind: 'unauthorized' }
  | { ok: false; kind: 'error' };

export async function getState(): Promise<State> {
  const r = await fetch('/api/state', { cache: 'no-store' });
  if (!r.ok) throw new Error(`GET ${r.status}`);
  return (await r.json()) as State;
}

export async function putState(state: State, token: string): Promise<PutResult> {
  let r: Response;
  try {
    r = await fetch('/api/state', {
      method: 'PUT',
      headers: { 'content-type': 'application/json', authorization: `Bearer ${token}` },
      body: JSON.stringify(state),
    });
  } catch {
    return { ok: false, kind: 'error' };
  }
  if (r.ok) return { ok: true, state: (await r.json()) as State };
  if (r.status === 401) return { ok: false, kind: 'unauthorized' };
  if (r.status === 409) {
    const body = (await r.json()) as { state: State };
    return { ok: false, kind: 'conflict', state: body.state };
  }
  return { ok: false, kind: 'error' };
}

export const readCache = (): State | null => {
  try {
    const v = localStorage.getItem(CACHE_KEY);
    return v ? (JSON.parse(v) as State) : null;
  } catch {
    return null;
  }
};

export const writeCache = (s: State) => {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(s));
  } catch {
    /* private mode / quota — display still works */
  }
};

export const readToken = (): string => {
  try {
    return localStorage.getItem(TOKEN_KEY) || '';
  } catch {
    return '';
  }
};

export const saveToken = (t: string) => {
  try {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
};
